import React from "react";
import { Link } from "react-router-dom";
import "../Styles/Award.css";

// const awards = [
//   {
//     id: 1,
//     title: "Excellence in Business Award",
//     year: "2025",
//     image: "/awards/award1.jpg",
//     description:
//       "Recognized for exceptional business performance and industry leadership.",
//   },
//   {
//     id: 2,
//     title: "Customer Choice Award",
//     year: "2024",
//     image: "/awards/award2.jpg",
//     description:
//       "Awarded for outstanding customer satisfaction and service quality.",
//   },
//   {
//     id: 3,
//     title: "Best Emerging Brand",
//     year: "2024",
//     image: "/awards/award3.jpg",
//     description:
//       "Recognized for innovation and rapid market growth.",
//   },
// ];

function Awards() {
  return (
    <div className="awards-page">

{/* Hero Section */}
<section className="hero">
        <div className="overlay"></div>

        <div className="hero-content">
          <h1>Awards & Recognition</h1>
          <p>
            Celebrating excellence, innovation and achievements that define our
            journey.
          </p>
        </div>
      </section>

{/* Intro */}
<section className="intro">
        <h2>Our Journey of Excellence</h2>

        <p>
          At Swastika, every award reflects our commitment to quality,
          innovation and customer satisfaction. These recognitions inspire us
          to continue delivering exceptional value.
        </p>
      </section>

{/* Awards Grid */}
{/* <section className="awards-section">
        <div className="awards-grid">
          {awards.map((award) => (
            <div className="award-card" key={award.id}>
              <div className="image-wrapper">
                <img src={award.image} alt={award.title} />
              </div>

              <div className="card-content">
                <span>{award.year}</span>

                <h3>{award.title}</h3>

                <p>{award.description}</p>
              </div>
            </div>
          ))}
        </div> 
      </section> */}
    <section className="featured-award">
      <div className="featured-award-container">

        {/* LEFT - IMAGE */}
        <div className="award-image-wrap">
          <img src="/images/Award/1.jpeg"  alt="Swastika Infra Award"  className="award-image"
          />

          <div className="award-image-overlay"></div>

          {/* <span className="award-number">01</span> */}
        </div>

        {/* RIGHT - CONTENT */}
        <div className="award-content">

          {/* <span className="award-eyebrow">
            FEATURED RECOGNITION
          </span> */}

          <div className="award-line"></div>

          <h2>
            Excellence in
            <br />
            <span>Infrastructure</span>
          </h2>

          <p className="award-description">
           At the Energy Conclave and Awards, Swastika Infra was honoured with the *“Leading Power & Energy EPC Company of the Year”* award. The highlight of the evening was our Chairperson, Shri Babulal Gupta, receiving this recognition on behalf of the organization. The award was presented by Shri Heeralal Nagar, State Minister, Energy Department, Government of Rajasthan, and Shri Rohit Gupta, Chairman and Managing Director, Rajasthan Renewable Energy Corporation. This moment stands as a reflection of Shri Babulal Gupta’s leadership and vision, which continue to guide Swastika Infra’s journey in building strong and reliable power infrastructure across the country. We remain committed to contributing meaningfully to India’s growing energy ecosystem, with the same focus and consistency that brought us here
          </p>

          <div className="award-meta">
            {/* <span className="award-year">2025</span> */}

            <div className="award-details">
              <span>AWARDED BY</span>
              <strong>Shri Heeralal Nagar </strong>
              <p>State Minister, Energy Department <br /> Rajasthan</p>
            </div>
          </div>

          {/* <button className="award-button">
            VIEW RECOGNITION
            <span>↗</span>
          </button> */}

        </div>

      </div>
    </section>



{/* Timeline */}
<section className="timeline">
        <h2>Recognition Timeline</h2>

        <div className="timeline-container">
          <div className="timeline-item">
            <h3>2025</h3>
            <p>Excellence in Business Award</p>
          </div>

          <div className="timeline-item">
            <h3>2024</h3>
            <p>Customer Choice Award</p>
          </div>

          <div className="timeline-item">
            <h3>2023</h3>
            <p>Innovation Excellence Recognition</p>
          </div>
        </div>
      </section>

{/* Stats */}
<section className="stats">
        <div className="stat-box">
          <h2>25+</h2>
          <p>Awards Won</p>
        </div>

        <div className="stat-box">
          <h2>100+</h2>
          <p>Recognitions</p>
        </div>

        <div className="stat-box">
          <h2>10K+</h2>
          <p>Happy Clients</p>
        </div>

        <div className="stat-box">
          <h2>20+</h2>
          <p>Years Experience</p>
        </div>
      </section>

{/* CTA */}
<section className="cta">
        <h2>Excellence Recognized</h2>

        <p>
          Every recognition motivates us to continue raising the standard of
          excellence.
        </p>

        
          <Link to="/Contact"><button>Contact Us</button></Link>

      </section>

    </div>
  );
}

export default Awards;